import { render, staticRenderFns } from "./ExportStudents.vue?vue&type=template&id=ed38b734&"
import script from "./ExportStudents.vue?vue&type=script&lang=js&"
export * from "./ExportStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports